export default {
  sections: {
    payment: 'Plată',
  },
  labels: {
    proceed_to_payment: 'Continuați la plată prin link sau scanați codul QR',
  },
  buttons: {
    generate_new_link: 'Generați link nou',
    copy_link: 'Copiați linkul',
    pay_now: 'Plătește acum',
  },
  toasts: {
    failed_to_create_payment_link: 'Eroare la încărcarea linkului de plată',
  },
};
